import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getAllMusicOnHold, getPurchaseInfoRequest, postGetAllCompany } from '../apiRequests/commonRequests'
import { getNotificationCount } from '../apiRequests/notificationRequest'





function* handleGetALLMusicOnHold() {
    try {
        const response = yield call(getAllMusicOnHold)
        yield put({
            type: types.GET_ALL_MUSIC_ON_HOLD_SUCCESS,
            action: response,
        })
    } catch (error) {
        console.log(error)
        // yield put({
        //     type: ,
        //     error: error.response,
        // })
    }
}


function* handleGetPurchaseInfoRequest(action) {
    try {
        const response = yield call(getPurchaseInfoRequest, action.id)
        yield put({
            type: types.GET_GTM_PURCHASE_INFO_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_GTM_PURCHASE_INFO_ERROR,
            error: error.response,
        })
    }
}

function* handlePostGetAllCompany(action) {
    try {

        const response = yield call(postGetAllCompany, action.params)

        yield put({
            type: types.GET_ALL_COMPONY_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_ALL_COMPONY_ERROR,
            error: error.response,
        })
    }
}
function* watcherCommonSaga() {
    // yield takeEvery(types.GET_ALL_MUSIC_ON_HOLD, handleGetALLMusicOnHold)
    yield takeEvery(types.GET_GTM_PURCHASE_INFO_REQUEST, handleGetPurchaseInfoRequest)
    yield takeEvery(types.GET_ALL_COMPANY_REQUEST, handlePostGetAllCompany)

}

export default watcherCommonSaga
